
import axios from "axios";

const FETCH_CANDLESTICK_PENDING = "FETCH_CANDLESTICK_PENDING";
const FETCH_CANDLESTICK_SUCCESS = "FETCH_CANDLESTICK_SUCCESS";
const FETCH_CANDLESTICK_ERROR = "FETCH_CANDLESTICK_ERROR";

export const fetchCandlestickPending = () => ({
  type: FETCH_CANDLESTICK_PENDING,
});

export const fetchCandlestickSuccess = (data) => ({
  type: FETCH_CANDLESTICK_SUCCESS,
  payload: data,
});

export const fetchCandlestickError = (error) => ({
  type: FETCH_CANDLESTICK_ERROR,
  payload: error,
});


// Helper function to format a Date as local ISO string without the 'Z' suffix
const toLocalISOString = (date) => {
  const pad = (num) => String(num).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const alternateSymbols = {
  US500: 'SPXUSD',
  US30: 'DOWUSD',
  NAS100: 'NDXUSD',
  JPN225: 'JPXJPY',
  GER30: 'G30EUR',
  UK100: 'UKXGBP',
  EUSTX50: 'E50EUR',
  HK50: 'HSIHKD',
}

export const fetchCandlestickData = ({ symbol, candleStickTime, platform, period, setChartLoading, idToken, specificTimes, activeTimeFrame, setRenderInfo, information }) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  };

  let query = null;

  const { start_date, end_date } = period;


  const updatedSymbol = alternateSymbols[symbol?.toUpperCase()] || symbol?.toUpperCase();

  function shiftHours(dateStr, hours) {
    const date = new Date(dateStr);
    date.setHours(date.getHours() + hours);

    const pad = n => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }



  const formattedStartDate = shiftHours(start_date, -6);
  const formattedEndDate = shiftHours(end_date, 6);

  const splitTrades = (trades) => {
    if (!Array.isArray(trades) || trades.length === 0) return { earliest: null, latest: null };

    return trades.reduce(
      (result, trade) => {
        const tradeDate = new Date(trade.date || trade.tradeDateTime);

        if (!result.earliest || tradeDate < new Date(result.earliest.date || result.earliest.tradeDateTime)) {
          result.earliest = trade;
        }

        if (!result.latest || tradeDate > new Date(result.latest.date || result.latest.tradeDateTime)) {
          result.latest = trade;
        }

        return result;
      },
      { earliest: null, latest: null }
    );
  };

  // inside your component
  const { earliest, latest } = splitTrades(information || []);
  // ✅ Calculate timeline based on open vs close difference
  let timeline = "one_minute"; // default
  if (earliest && latest) {
    const openTime = new Date(earliest?.date || earliest?.tradeDateTime);
    const closeTime = new Date(latest?.date || latest?.tradeDateTime);
    const diffHours = Math.abs(closeTime - openTime) / (1000 * 60 * 60); // ms → hours

    timeline = diffHours <= 48 ? "one_second" : "one_minute";
  }

  const tradeType = (position_type) => {
    const type = position_type?.action || position_type?.side;
    return type
  }

  query = `?start_date=${formattedStartDate}&end_date=${formattedEndDate}&timeline=${timeline}`;

  try {
    dispatch(fetchCandlestickPending());
    setChartLoading(true);
    setRenderInfo(false);

    const url = `https://tickdata.alphacapitalgroup.uk/api/symbol/${updatedSymbol.toLowerCase()}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(config?.headers || {}),
      },
      body: JSON.stringify({
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        timeline,
        direction: tradeType(earliest) === 'Buy' ? 'long' : 'short',

        open_time: earliest?.date || earliest?.tradeDateTime,
        close_time: latest?.date || latest?.tradeDateTime,
        open_price: earliest?.price,
        close_price: latest?.price,
      })
    });



    const data = await response.json();
    dispatch(fetchCandlestickSuccess(data));
    setChartLoading(false);
    setRenderInfo(true);
  } catch (error) {
    dispatch(fetchCandlestickError(error?.response?.data || "Fetch failed"));
    setChartLoading(false);
    setRenderInfo(true);
    dispatch(fetchCandlestickSuccess([]))
  }
};



const initialState = {
  chartData: [],
  loading: false,
  error: null,
};

const candlestickReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CANDLESTICK_PENDING:
      return {
        chartData: [],
        loading: true,
        error: null,
      };
    case FETCH_CANDLESTICK_SUCCESS:
      return {
        ...state,
        loading: false,
        chartData: action.payload,
      };
    case FETCH_CANDLESTICK_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default candlestickReducer;
